import { render, staticRenderFns } from "./day-grid-button.vue?vue&type=template&id=63b12bc8&"
import script from "./day-grid-button.vue?vue&type=script&lang=js&"
export * from "./day-grid-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports